export const PHONE_MASK = [
  '3', '8', '0', '(', /[0-9]/, /[0-9]/, ')', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/
];

export const PHONE_MASK_DEFINITIONS = {
  '0': /[0-9]/
};

export enum Roles {
  ADMIN = 'Admin',
  SUPPLIER = 'Supplier',
  FARMER = 'Farmer',
  MERCHANDISER = 'Merchandiser',
  TRADER = 'Trader',
  AGENT = 'Agent'
}
